// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"eYd-b","smallLinkTypography":"X-nsq","titleTypography":"_1Chw-","cardTitleTypography":"_1y1xv","truncate":"_2QNUS","base":"_1xd0-","section":"wpW0t","sectionTitle":"_2k9Rm","sectionContent":"_2Q8gg","sectionLoading":"_3vpou","sectionFooter":"HejcD","callToAction":"_3JjKB","footerCallToAction":"_2b3M-","linkButton":"DB8it","button":"_1EsmP","tip":"_3zKY4","panel":"_3qntC","uploadSection":"_1uRRp","footer":"_3_0_F","buttonBorder":"_1P69y"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerHierarchy/Hierarchies.scss
// module id = 2689
// module chunks = 0